import { render } from "./TableLimitComponent.vue?vue&type=template&id=6204b462&scoped=true"
import script from "./TableLimitComponent.vue?vue&type=script&lang=js"
export * from "./TableLimitComponent.vue?vue&type=script&lang=js"

import "./TableLimitComponent.vue?vue&type=style&index=0&id=6204b462&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6204b462"],['__file',"resources/js/components/admin/components/TableLimitComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6204b462"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6204b462', __exports__)) {
    api.reload('6204b462', __exports__)
  }
  
  module.hot.accept("./TableLimitComponent.vue?vue&type=template&id=6204b462&scoped=true", () => {
    api.rerender('6204b462', render)
  })

}


export default __exports__